import React from 'react';
import PageLayout from '../components/PageLayout';

/**
 * Privacy Policy page component
 */
const PrivacyPolicyPage: React.FC = () => {
  return (
    <PageLayout 
      title="Privacy Policy" 
      subtitle="How we protect and manage your information"
      backgroundImage="https://images.pexels.com/photos/6574926/pexels-photo-6574926.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
    >
      <section className="content-card">
        <h2>Privacy Policy</h2>
        <p><strong>Last Updated: April 19, 2025</strong></p>
        
        <p>
          At GolfScape, we take your privacy seriously. This Privacy Policy explains how we collect, 
          use, disclose, and safeguard your information when you visit our website or use our tee time 
          booking service. Please read this policy carefully. If you do not agree with the terms of this 
          privacy policy, please do not access the site.
        </p>
        
        <h3>Information We Collect</h3>
        <p>
          We collect information that you provide directly to us when registering for an account, 
          booking a tee time, or communicating with us:
        </p>
        <ul>
          <li>Personal information such as name, email address, phone number, and billing information</li>
          <li>Booking preferences and history</li>
          <li>Golf skill level and handicap (if provided)</li>
          <li>Communications you send to our customer service team</li>
        </ul>
        
        <p>
          We also collect certain information automatically when you visit our website:
        </p>
        <ul>
          <li>IP address and device information</li>
          <li>Browser type and settings</li>
          <li>Referring website address</li>
          <li>Information about how you use our website</li>
          <li>Cookies and similar technologies</li>
        </ul>
        
        <h3>How We Use Your Information</h3>
        <p>
          We use the information we collect to:
        </p>
        <ul>
          <li>Process and confirm your tee time bookings</li>
          <li>Manage your account and provide customer support</li>
          <li>Communicate with you about bookings, promotions, and updates</li>
          <li>Improve our website and services</li>
          <li>Analyze usage patterns and trends</li>
          <li>Protect against fraud and unauthorized transactions</li>
        </ul>
        
        <h3>Sharing Your Information</h3>
        <p>
          We may share your information with:
        </p>
        <ul>
          <li>Golf courses where you book tee times (limited to information needed for your booking)</li>
          <li>Service providers who perform services on our behalf (payment processors, email delivery, etc.)</li>
          <li>Business partners with your consent</li>
          <li>Legal authorities when required by law or to protect our rights</li>
        </ul>
        
        <h3>Your Choices</h3>
        <p>
          You can control your information in the following ways:
        </p>
        <ul>
          <li>Update or correct your account information at any time</li>
          <li>Opt-out of marketing communications</li>
          <li>Manage cookie preferences through your browser settings</li>
          <li>Request deletion of your account by contacting our support team</li>
        </ul>
        
        <h3>Security</h3>
        <p>
          We implement appropriate technical and organizational measures to protect your personal 
          information. However, no method of transmission over the Internet or electronic storage 
          is 100% secure, and we cannot guarantee absolute security.
        </p>
        
        <h3>Children's Privacy</h3>
        <p>
          Our services are not intended for individuals under the age of 16. We do not knowingly 
          collect personal information from children under 16. If you believe we have collected 
          information from a child under 16, please contact us.
        </p>
        
        <h3>Changes to This Policy</h3>
        <p>
          We may update this privacy policy from time to time. We will notify you of any changes 
          by posting the new policy on this page and updating the "Last Updated" date.
        </p>
        
        <h3>Contact Us</h3>
        <p>
          If you have questions about this Privacy Policy, please contact us at:
        </p>
        <p>
          Email: privacy@golfscape.com<br />
          Address: 123 Fairway Drive, Suite 200, Scottsdale, AZ 85255<br />
          Phone: (555) 123-4567
        </p>
      </section>
    </PageLayout>
  );
};

export default PrivacyPolicyPage;
